import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, RouterOutlet } from '@angular/router';
import {
  initBraze,
  userAuthenticated$,
  userLoggedOut$,
} from '@libs/account-manager';
import { dispatch } from '@ngneat/effects';
import { LogoutComponent } from '@tmx/auth';
import { SubscriptionManager } from '@tmx/core';

import { VERSION } from '../version';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <tmx-logout></tmx-logout>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        width: 100%;
      }
    `,
  ],
  imports: [RouterOutlet, LogoutComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private readonly metaService = inject(Meta);
  private readonly router = inject(Router);
  private readonly sm = new SubscriptionManager();

  ngOnInit() {
    dispatch(initBraze());
    userAuthenticated$.subscribe({
      next: () => {
        this.router.navigateByUrl('/ams');
      },
    });
    this.metaService.addTag({ name: 'version', version: VERSION });

    this.sm.manage = userLoggedOut$.subscribe({
      next: () => {
        this.router.navigateByUrl('/auth/login');
      },
    });
  }
}
